import { render, staticRenderFns } from "./EventOverview.vue?vue&type=template&id=5987a244&scoped=true"
import script from "./EventOverview.vue?vue&type=script&lang=js"
export * from "./EventOverview.vue?vue&type=script&lang=js"
import style0 from "./EventOverview.vue?vue&type=style&index=0&id=5987a244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987a244",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculeButtonMobileLyre: require('/home/userapp/components/Molecule/Button/ButtonMobileLyre.vue').default,MoleculeButtonBreadcrumbBack: require('/home/userapp/components/Molecule/Button/ButtonBreadcrumbBack.vue').default,OrganismOverviewHeaderAndFilters: require('/home/userapp/components/Organism/OverviewHeaderAndFilters.vue').default,MoleculeCardResultInline: require('/home/userapp/components/Molecule/Card/CardResultInline.vue').default,MoleculeComponentJoin: require('/home/userapp/components/Molecule/ComponentJoin.vue').default,MoleculeCardEventAndSeries: require('/home/userapp/components/Molecule/Card/CardEventAndSeries.vue').default,MoleculeCardEventAndSeriesV2: require('/home/userapp/components/Molecule/Card/CardEventAndSeriesV2.vue').default,MoleculeCardBanner: require('/home/userapp/components/Molecule/Card/CardBanner.vue').default,OrganismPagination: require('/home/userapp/components/Organism/Pagination.vue').default,OrganismPaginationV2: require('/home/userapp/components/Organism/PaginationV2.vue').default,MoleculeABTestWrapper: require('/home/userapp/components/Molecule/ABTestWrapper.vue').default,TemplateBase: require('/home/userapp/components/Template/Base.vue').default})
